jQuery.noConflict();
jQuery(document).ready(function($) {
  $(window).on('load', function(){
    $('.previous_auction_catalogs').each(function(){
      let container = $(this);
      hideCatalog(container, true);
    });
  });

  let prevColSize = $('.previous_auction_col_3').first().width();
  $(window).resize(function(){
    //If col shrink
    if(prevColSize > $('.previous_auction_col_3').first().width()){
      $('.previous_auction_catalogs').each(function(){
        let container = $(this);
        hideCatalog(container, false);
      });
    }
    //If col enlarge
    else{
      $('.previous_auction_catalogs').each(function(){
        let container = $(this);
        showCatalog(container);
      });
    }
    prevColSize = $('.previous_auction_col_3').first().width();
  })

  //Click on left arrow
  $('.previous_auction_catalogs_next').click(function(event){
    event.preventDefault();
    if($(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').last().next('.previous_auction_catalog:not(.shown)').length){
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').last().next('.previous_auction_catalog:not(.shown)').show().addClass('shown');
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').first().hide().removeClass('shown');
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalogs_prev').removeClass('inactive');
    }
    if(!$(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').last().next('.previous_auction_catalog:not(.shown)').length){
      $(this).addClass('inactive');
    }
  })

  //Click on right arrow
  $('.previous_auction_catalogs_prev').click(function(event){
    event.preventDefault();
    if($(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').first().prev('.previous_auction_catalog:not(.shown)').length){
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').first().prev('.previous_auction_catalog:not(.shown)').show().addClass('shown');
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').last().hide().removeClass('shown');
      $(this).closest('.previous_auction_catalogs').find('.previous_auction_catalogs_next').removeClass('inactive');
    }
    if(!$(this).closest('.previous_auction_catalogs').find('.previous_auction_catalog.shown').first().prev('.previous_auction_catalog:not(.shown)').length){
      $(this).addClass('inactive');
    }
  })

  function hideCatalog(container, loadWidth){

    let catalogsContainer = container.find('.previous_auction_catalogs_container');

    //If content is offset
    if (container.prop('offsetWidth') < container.prop('scrollWidth')) {
      container.find('.previous_auction_catalogs_next').addClass('shown');
      container.find('.previous_auction_catalogs_prev').addClass('shown');

      //Hide all offset elements
      let maxHeight = 0;
      catalogsContainer.find('.previous_auction_catalog:visible').each(function(){
        if(loadWidth){
          if(maxHeight < $(this).innerHeight()){
            maxHeight = $(this).innerHeight();
          }
          $(this).attr('data-width', Math.round($(this).innerWidth()));
        }
        if ($(this).prop('offsetLeft') + $(this).prop('offsetWidth') >
        catalogsContainer.prop('offsetLeft') + catalogsContainer.prop('offsetWidth')){
          $(this).hide();
          $(this).removeClass('shown');
          container.find('.previous_auction_catalogs_next').removeClass('inactive');
        }
      });
      if(loadWidth){
        catalogsContainer.find('.previous_auction_catalog').css('min-height', maxHeight);
      }

      //Hide last element if right arrow is offset
      while (container.find('.previous_auction_catalogs_next').prop('offsetLeft') + container.find('.previous_auction_catalogs_next').prop('offsetWidth') >
      container.prop('offsetLeft') + container.prop('offsetWidth')){
        container.find('.previous_auction_catalog.shown').last().hide().removeClass('shown');
        container.find('.previous_auction_catalogs_next').removeClass('inactive');
      }
    }
    else {
      let maxHeight = 0;
      if(loadWidth){
        catalogsContainer.find('.previous_auction_catalog:visible').each(function(){
          if(maxHeight < $(this).innerHeight()){
            maxHeight = $(this).innerHeight();
          }
          $(this).attr('data-width', Math.round($(this).outerWidth()));
        });
        catalogsContainer.find('.previous_auction_catalog').css('min-height', maxHeight);
      }
    }
  }

  function showCatalog(container){
    while(true===true){
      let catalogHiddenAfter = container.find('.previous_auction_catalog.shown').last().next('.previous_auction_catalog:not(.shown)');
      let catalogHiddenBefore = container.find('.previous_auction_catalog.shown').first().prev('.previous_auction_catalog:not(.shown)')
      let catalogsContainer = container.find('.previous_auction_catalogs_container');
      let catalogsShownWidth = 0;
      container.find('.previous_auction_catalog.shown').each(function(){
        catalogsShownWidth += $(this).data('width');
      });
      if(catalogHiddenAfter.length){
        if (catalogsContainer.innerWidth() - catalogsShownWidth > parseInt(catalogHiddenAfter.data('width'))) {
          catalogHiddenAfter.addClass('shown').show();
        }
        else{break;}
      }
      else if (catalogHiddenBefore.length){
        if (catalogsContainer.innerWidth() - catalogsShownWidth > parseInt(catalogHiddenBefore.data('width'))) {
          catalogHiddenBefore.addClass('shown').show();
          container.find('.previous_auction_catalogs_next').addClass('inactive');
        }
        else{break;}
      }
      else{
        container.find('.previous_auction_catalogs_next').removeClass('shown');
        container.find('.previous_auction_catalogs_prev').removeClass('shown');
        break;
      }
    }
  }
});
